import map from "lodash/map";
import uniq from "lodash/uniq";
import reduce from "lodash/reduce";

export default function getAllChapters(state) {
  const chapterTypes = uniq(
    map(state.story.chapters, (chapter) => chapter.schema),
  );

  return reduce(
    map(chapterTypes, (type) => state.story.entities[type]),
    (memo, chapters) => ({
      ...memo,
      ...chapters,
    }),
  );
}
